import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import "../styles/home.css";

const API_URL = "https://ecommerce-backend-zxtw.onrender.com";

const OrderSuccess = () => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [message, setMessage] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  const { paymentId, total } = location.state || {};

  useEffect(() => {
    const pending = localStorage.getItem("pendingRazorpayVerification");

    if (pending) {
      const payload = JSON.parse(pending);
      setIsVerifying(true);
      setMessage("Finalizing your order, please wait...");

      fetch(`${API_URL}/api/payment/verify-payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then((res) => res.json())
        .then((data) => {
          setIsVerifying(false);
          if (data.success) {
            setMessage("Order saved successfully.");
            localStorage.removeItem("pendingRazorpayVerification");
          } else {
            setMessage("Order save failed, please contact support.");
            console.error("Pending verify failed:", data);
          }
        })
        .catch((err) => {
          setIsVerifying(false);
          setMessage("Network error while saving order.");
          console.error("Pending verify error:", err);
        });
    }
  }, []);


  return (
    <>
      <Navbar />

      <div className="success-container">

        <div className="success-card">

          <h1>🎉 Order Successful</h1>

          <p>Your payment was completed successfully.</p>

          <div className="success-details">

            <p>
              <strong>Payment ID:</strong> {paymentId || "N/A"}
            </p>

            <p>
              <strong>Total Paid:</strong> ₹{total || "0"}
            </p>

          </div>

          {isVerifying ? (
            <p style={{ color: "#007bff" }}>{message}</p>
          ) : (
            message && <p style={{ color: "#2d8a2d" }}>{message}</p>
          )}

          <button
            className="continue-btn"
            onClick={() => navigate("/")}
          >
            Continue Shopping
          </button>

        </div>

      </div>
      <BottomNav />
    </>
  );
};

export default OrderSuccess;